/**
 * Clés de cache du domaine `users` — les fiches PUBLIQUES d'autres utilisateurs
 * (coéquipiers, auteur d'un brouillon partagé, propriétaire d'une équipe). Le
 * profil de l'utilisateur connecté, lui, est dans `session`.
 *
 * Voir `src/hooks/profile/keys.ts` pour le pourquoi de la fabrique.
 */
export const userKeys = {
  all: ['users'] as const,

  /** `GET /user/:id` : la fiche publique d'un utilisateur. */
  one: (id: string) => [...userKeys.all, 'one', id] as const,
} as const;
